<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 0.9em
}
</style>
